import { Container, Flex, Title, Text, createStyles } from "@mantine/core"
import { Image } from "shared/ui/Image"
import image from "shared/assets/error.svg"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  title: {
    [theme.fn.smallerThan("sm")]: {
      fontSize: theme.headings.sizes.h2.fontSize,
    },
  },
}))

// ----------------------------------------------------------------------

type Props = {
  errorMessage: string
};

export function ErrorResult({ errorMessage }: Props): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Container size="md" my={48} p={0}>
      <Flex direction="column" align="center" justify="center">
        <Image src={image} alt="Нет данных"
               maw={288}
               objectFit="contain"/>
        <Title align="center" mt="xl" className={classes.title}>
          Ошибка загрузки данных
        </Title>
        <Text align="center" c="dimmed" mt="xs">
          {errorMessage}
        </Text>
      </Flex>
    </Container>
  )
}
